import React from 'react';
import { observer } from 'mobx-react';
import {
    TemplatesList,
    TemplatesListItem
} from '../StepSideBar/StepSideBar.styles';
import TemplateSelectEmptyState from './TemplateSelectEmptyState';
import { arraySorter } from '../../../../../utils/sort.utils';
import TemplatesListItemWrapper from '../Components/TemplatesListItemWrapper';
import { useRootStore } from '~/stores/useRootStore';

interface Props {
    onClose: () => void;
}

const TemplateSelectSideBarBrochure = ({ onClose }: Props) => {
    const {
        automationUiStore: { selectedStep },
        companyStore: { currCompany }
    } = useRootStore();

    const handleTemplateSelect = (id: string) => {
        selectedStep.selectFileTemplate(id);
        onClose();
    };

    const sortedBrochures = arraySorter(currCompany?.brochures);

    const isSelected = (id: string) => id === selectedStep?.fileTemplateId;

    return (
        <TemplatesList>
            {sortedBrochures?.length ? (
                sortedBrochures.map(({ _id, title }) => (
                    <TemplatesListItemWrapper
                        key={_id}
                        isSelected={isSelected(_id)}
                        onClick={() => handleTemplateSelect(_id)}
                    >
                        <TemplatesListItem>{title}</TemplatesListItem>
                    </TemplatesListItemWrapper>
                ))
            ) : (
                <TemplateSelectEmptyState
                    type="brochure"
                    testIdName="brochure-empty-state"
                />
            )}
        </TemplatesList>
    );
};

export default observer(TemplateSelectSideBarBrochure);
